import { apiSlice } from '../../api';
import type {
  DeleteRateMarkupGroupsDTO,
  DeleteRateMarkupGroupsResult,
  GetRateMarkupDTO,
  GetRateMarkupGroupDTO,
  GetRateMarkupGroupResult,
  GetRateMarkupResult,
  GetRateMarkupsDTO,
  GetRateMarkupsResult,
  PostRateMarkupGroupsDTO,
  PostRateMarkupGroupsResult,
  PutRateMarkupGroupsDTO,
  PutRateMarkupGroupsResult,
  UpdateRateMarkupDTO,
  UpdateRateMarkupResult,
} from './types';

export const rateMarkupEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getRateMarkups: build.query<GetRateMarkupsResult, GetRateMarkupsDTO>({
        query: ({ rate_markup_group_id }) => ({
          url: `/admin/v1/rate-markup-groups/${rate_markup_group_id}/rate-markups`,
          method: 'GET',
        }),
        providesTags: ['RateMarkups'],
      }),

      getRateMarkup: build.mutation<GetRateMarkupResult, GetRateMarkupDTO>({
        query: ({ rateMarkupId, rate_markup_group_id }) => ({
          url: `/admin/v1/rate-markup-groups/${rate_markup_group_id}/rate-markups/${rateMarkupId}`,
          method: 'GET',
        }),
      }),

      updateRateMarkup: build.mutation<UpdateRateMarkupResult, UpdateRateMarkupDTO>({
        query: ({ body, rate_markup_group_id }) => ({
          url: `/admin/v1/rate-markup-groups/${rate_markup_group_id}/rate-markups`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['RateMarkups'],
      }),

      getRateMarkupGroups: build.query<GetRateMarkupGroupResult, GetRateMarkupGroupDTO>({
        query: () => ({
          url: '/admin/v1/rate-markup-groups',
          method: 'GET',
        }),
        providesTags: ['RateMarkups'],
      }),

      postRateMarkupGoups: build.mutation<PostRateMarkupGroupsResult, PostRateMarkupGroupsDTO>({
        query: (body) => ({
          url: '/admin/v1/rate-markup-groups',
          method: 'POST',
          body,
        }),
      }),

      putRateMarkupGoups: build.mutation<PutRateMarkupGroupsResult, PutRateMarkupGroupsDTO>({
        query: ({ body, rate_markup_group_id }) => ({
          url: `/admin/v1/rate-markup-groups/${rate_markup_group_id}`,
          method: 'PUT',
          body,
        }),
      }),

      deleteRateMarkupGoups: build.mutation<
        DeleteRateMarkupGroupsResult,
        DeleteRateMarkupGroupsDTO
      >({
        query: ({ rate_markup_group_id }) => ({
          url: `/admin/v1/rate-markup-groups/${rate_markup_group_id}`,
          method: 'DELETE',
        }),
      }),
    };
  },
});

export const {
  useGetRateMarkupsQuery,
  useGetRateMarkupGroupsQuery,
  useGetRateMarkupMutation,
  useLazyGetRateMarkupGroupsQuery,
  useLazyGetRateMarkupsQuery,
  useUpdateRateMarkupMutation,
  useDeleteRateMarkupGoupsMutation,
  usePostRateMarkupGoupsMutation,
  usePutRateMarkupGoupsMutation,
} = rateMarkupEndpoints;

export type RateMarkupsController = typeof rateMarkupEndpoints;
